/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Op_LteInputs */

const cs_op_lte = /** @type {(inputs: Op_LteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<=`)
};

const en_op_lte = /** @type {(inputs: Op_LteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<=`)
};

/**
* | output |
* | --- |
* | "<=" |
*
* @param {Op_LteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const op_lte = /** @type {((inputs?: Op_LteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Op_LteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_op_lte(inputs)
	return cs_op_lte(inputs)
});